import React, { createContext, useContext, useMemo, useState } from 'react';
import { Modal } from '@wix/design-system';
const ModalContext = createContext(undefined);
export function ModalProvider(props) {
    const [modalContent, setModalContent] = useState(null);
    const isOpen = modalContent !== null;
    const open = (requestedModalContent) => {
        setModalContent(requestedModalContent);
    };
    const close = () => {
        setModalContent(null);
    };
    const modalControls = useMemo(() => ({
        open,
        close,
    }), []);
    return (React.createElement(ModalContext.Provider, { value: modalControls },
        props.children,
        React.createElement(Modal, { isOpen: isOpen }, modalContent)));
}
export function useModal() {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal should be used inside a ModalProvider');
    }
    return context;
}
//# sourceMappingURL=use-modal.js.map